import * as React from 'react';
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Button } from "primereact/button";

const medicineList = (props) => {

	return (
		<DataTable
			value={props.medicines}
			paginator={true}
			lazy={true}
			rows={props.rows}
			totalRecords={props.totalRecords}
			onPage={(event) => props.onPageClick(event)}
			first={props.first}
			dataKey='medicineId'
		//loading={props.isLoading}	
		>
			<Column field="brandName" header="Brand Name"
				body={(rowData, column) =>
					rowData && rowData.medicineContent && rowData.medicineContent.length ?
						rowData.medicineContent
							.filter(x => typeof x.brandName === 'string' && x.brandName.length > 0)
							.map(r => r.brandName)
							.join(' / ')
						: null
				} />
			<Column field="additionalTitle" header="Title"
				body={(rowData, column) =>
					rowData && rowData.medicineContent && rowData.medicineContent.length ?
						rowData.medicineContent
							.filter(x => typeof x.additionalTitle === 'string' && x.additionalTitle.length > 0)
							.map(r => r.additionalTitle)
							.join(' / ')
						: null
				} />
			<Column field="medicineNumber" header="Number" />
			<Column
				header="Actions"
				style={{ textAlign: "center", width: "8em" }}
				body={(rowData, column) =>
					<div>
						<Button
							type="button"
							icon="pi pi-pencil"
							className="p-button-warning"
							tooltip="Edit"
							tooltipOptions={{ position: 'top' }}
							style={{ marginRight: ".5em" }}
							onClick={() => props.editClick(rowData.medicineId)}
						/>
						<Button
							type="button"
							icon="pi pi-trash"
							className="p-button-danger"
							tooltip="Delete"
							tooltipOptions={{ position: 'top' }}
							onClick={() => props.deleteClick(rowData.medicineId)}
						/>
					</div>
				}
			/>
		</DataTable>
	)
}

export default medicineList;
